import superagent from 'superagent';

const apiHost = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
const methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
	if(path.indexOf("http") > -1 ){
		return path;
	}

	const adjustedPath = path[0] !== '/' ? '/' + path : path;
	return apiHost + adjustedPath;
}

class ApiClient_ {
	constructor(req) {
		methods.forEach((method) =>
			this[method] = (path, options) => new Promise((resolve, reject) => {
				const request = superagent[method](formatUrl(path));

				request.set('Content-Type', 'application/json');
				if (options && options.params) {
					request.query(options.params);
				}

				if (options && options.headers) {
					request.set(options.headers);
				}

				if (options && options.attach) {
					delete request.header['Content-Type'];
					for (const i in options.attach) {
						if (options.attach.hasOwnProperty(i)) {
							request.attach(i, options.attach[i], options.attach[i].name || null );
						}
					}
				}

				if (options && options.auth) {
					request.set('Authorization', options.auth);
				}

				//TODO: fix token header setup
				if(localStorage.getItem("token")){
					request.set("x-access-token", localStorage.getItem('token'));
				}

				if (options && options.field) {
					for (const i in options.field) {
						if (options.field.hasOwnProperty(i)) {
							request.field(i, options.field[i]);
						}
					}
				}

				if (options && options.progress) {
					request.on('progress', options.progress);
				}

				if (options && options.data) {
					request.send(options.data);
				}

				// if (__SERVER__ && req.get('cookie')) {
				// 	request.set('cookie', req.get('cookie'));
				// }

				request.end((err, res) => {
					if (err) {
						const errData = res ? res.body || err : err;
						if (typeof errData === 'object') {
							console.log('api client -->', errData);
							reject({status: res.status, ...errData});
						} else {
							reject({status: res.status, message: errData});
						}
					} else {
						resolve(res.body);
					}
				});

			}));
	}
}

const ApiClient = ApiClient_;

export default ApiClient;